import { useInfiniteQuery } from '@tanstack/react-query'
import { getListLocation } from "../api/get-list-location"

export const useGetListLocation = ({ params, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-list-location', params],
    queryFn: ({ pageParam = 1 }) => getListLocation({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}
